import { Box } from '@mui/material';
import { Fragment, JSX } from 'react';

import { splitStrongSegments } from '@/components/formattedText/util/strongSegments.util.ts';

type Props = {
  text: string;
};

export const FormattedText = ({ text }: Props): JSX.Element => (
  <>
    {splitStrongSegments(text).map(segment =>
      segment.isStrong ? (
        <Box component="strong" key={segment.id} sx={{ fontWeight: 700 }}>
          {segment.text}
        </Box>
      ) : (
        <Fragment key={segment.id}>{segment.text}</Fragment>
      ),
    )}
  </>
);
